export enum Status {
  open = 'OPEN',
  authorized = 'AUTHORIZED',
  canceled = 'CANCELED',
  printed = 'PRINTED',
}

export const StatusColor = {
  [Status.open]: 'blue',
  [Status.authorized]: 'green',
  [Status.canceled]: 'red',
  [Status.printed]: 'gray',
};
